import { CurrencyCode } from 'types/currency';

import { makeLabels } from 'utils/i18n';

export const BREADCRUMBS = [
  ['breadcrumbs.payouts', 'Crypto Payouts'],
  ['breadcrumbs.payoutDetails', 'Payout Details'],
];

export const KEYS = {
  DATE_FORMAT: 'DD/MM/YYYY HH:mm:ss',
  HARDCODED_CURRENCY: CurrencyCode.USD,
};

export const MESSAGES_NAMESPACE = 'page.cryptoPayouts.view';

export const LABELS = makeLabels(
  {
    PAGE_TITLE: ['title', 'Crypto Payout Details'],
    LOADING_ERROR: ['loadingError', 'An error occurred while loading the crypto payout. Please try again later.'],
  },
  MESSAGES_NAMESPACE,
);
